<template>
  <div class="ayelet-emails w100">
    <h1 class="bold">
      Ayelet emails
      <br>
      <span>
        Send personalized Ayelet emails
      </span>
    </h1>

    <div>
      <textarea
        :value="prompts.prompt1"
        @input="handleInput($event, 'prompt1')"
        placeholder="Prompt 1" />

        <button class="purple-btn block"
                @click="handleSubmit()">
            <span class="spinner" v-if="isSaving"/>
            {{isSaving ? 'Saving...' : 'Save changes'}}
        </button>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from "vuex";
  import { computed } from "vue";

  const { state, dispatch, commit } = useStore();
  dispatch('get_ayelet_emails_prompts');

  const isSaving = computed(() => state.reqStatus === "saving");
  const prompts = computed(() => state.ayeletEmails.prompts);

  function handleInput (ev, key) {
    commit('SET_AYELET_EMAILS_PROMPT', { key, value: ev.target.value });
  }

  function handleSubmit () {
    dispatch('save_ayelet_emails_prompts')
  }
</script>

<style lang="scss">
  .ayelet-emails {
    > div {
      width: 100%;
      max-width: 648px;
      display: flex;
      flex-direction: column;
      gap: 16px;

      textarea {
        width: 100%;
        min-height: 448px;
      }

      .purple-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 52px;
      }
    }
  }
</style>